/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PostApiJingleCollectionsIdOrderMutationRequest, PostApiJingleCollectionsIdOrderMutationResponse, PostApiJingleCollectionsIdOrderPathParams, PostApiJingleCollectionsIdOrder400, PostApiJingleCollectionsIdOrder401, PostApiJingleCollectionsIdOrder403, PostApiJingleCollectionsIdOrder404, PostApiJingleCollectionsIdOrder500 } from "../../types/PostApiJingleCollectionsIdOrder.ts";
import { postApiJingleCollectionsIdOrderMutationResponseSchema, postApiJingleCollectionsIdOrderMutationRequestSchema } from "../../zod/JingleCollectionSchemas/postApiJingleCollectionsIdOrderSchema.ts";

function getPostApiJingleCollectionsIdOrderUrl({ id }: { id: PostApiJingleCollectionsIdOrderPathParams["Id"] }) {
  const res = { method: 'POST', url: `/api/jingle-collections/${id}/order` as const }  
  return res
}

/**
 * @summary Обновление порядка джинглов в подборке
 * {@link /api/jingle-collections/:Id/order}
 */
export async function postApiJingleCollectionsIdOrder({ id, data }: { id: PostApiJingleCollectionsIdOrderPathParams["Id"]; data?: PostApiJingleCollectionsIdOrderMutationRequest }, config: Partial<RequestConfig<PostApiJingleCollectionsIdOrderMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = postApiJingleCollectionsIdOrderMutationRequestSchema.parse(data)  
  
  const res = await request<PostApiJingleCollectionsIdOrderMutationResponse, ResponseErrorConfig<PostApiJingleCollectionsIdOrder400 | PostApiJingleCollectionsIdOrder401 | PostApiJingleCollectionsIdOrder403 | PostApiJingleCollectionsIdOrder404 | PostApiJingleCollectionsIdOrder500>, PostApiJingleCollectionsIdOrderMutationRequest>({ method : "POST", url : getPostApiJingleCollectionsIdOrderUrl({ id }).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return postApiJingleCollectionsIdOrderMutationResponseSchema.parse(res.data)
}